  import React, { useEffect, useState, useMemo, useRef } from 'react';
  import axios from "axios";
  import MDButton from "components/MDButton";
  import Box from '@mui/material/Box';
  import Modal from '@mui/material/Modal';
  import Typography from '@mui/material/Typography';
  import TextField from '@mui/material/TextField';
  import Grid from '@mui/material/Grid';
  import Stepper from '@mui/material/Stepper';
  import Step from '@mui/material/Step';
  import StepLabel from '@mui/material/StepLabel';
  import CircularProgress from "@mui/material/CircularProgress";
  import Kardex from "./kardex"; 
  import { FormControlLabel, Checkbox, MenuItem, Paper, Divider } from "@mui/material";
  import { fetchNextStudentCode } from "./codigo";
  import  PagosModal from "./pagosModal";
  import ProformaButton from "./proformaButton"; 
  import { Button } from '@mui/material';
  import Avatar from "@mui/material/Avatar";
  import { validarEstudiante } from './validaciones';
  import { apiGet, apiPost } from "../../../utils/api";
  import InscripcionCarreraModal from "./InscripcionCarreraModal";
  import { useTheme, useMediaQuery } from "@mui/material";

  import { useCallback } from 'react';
  import Table from "./EstudiantesTable"
  import ListaModal from "./ListaEstudiantesModal";
  import _ from 'lodash';
  import { useAlerta } from "utils/alertas";

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',

    width: {
      xs: '90%',   // 📱 celular
      sm: '80%',   // tablets
      md: 800,     // 💻 PC (igual que antes)
    },

    maxHeight: '90vh',
    overflowY: 'auto',
    boxShadow: 24,
    p: { xs: 2, sm: 3, md: 4 }, // opcional pero recomendado
    borderRadius: 2,
  };

  export default function EstudiantesInscritos() {
    const [estudiantes, setEstudiantes] = useState([]);
    const [open, setOpen] = useState(false);
    const [carreras, setCarreras] = useState([]);
    const [capacitaciones, setCapacitaciones] = useState([]);
    const [items, setItems] = useState([]);
    const steps = ['Datos del Estudiante', 'Datos de Inscripción', 'Nivel de formación', 'Datos de Pago'];
    const usuario = JSON.parse(sessionStorage.getItem("user"));
    const esRol1 = Number(usuario?.rol) === 1;
    const [kardexOpen, setKardexOpen] = useState(false);
    const [errorInscripcion, setErrorInscripcion] = useState(false);
    const [openPagos, setOpenPagos] = useState(false);
    const [kardexUserId, setKardexUserId] = useState(null);
    const API_BASE = process.env.REACT_APP_API_URL;
    const BASE_URL = API_BASE.replace("/api/v2", "");
    const [step, setStep] = useState(1);
    const [usuarioId, setUsuarioId] = useState(null);
    const [selectedUsuarioId, setSelectedUsuarioId] = useState(null);
    const [errors, setErrors] = useState({});
    const [codigo, setCodigo] = useState("");
    const [tipoPrograma, setTipoPrograma] = useState("");
    const [tipoCarrera, setTipoCarrera] = useState("");
    const [instituto, setInstituto] = useState("");     
    const norm = (t) => (t || "").toLowerCase().trim();
    const [duracion, setDuracion] = useState("");  
    const [nit_ci, setNit_ci]= useState("");      
    const [programas, setProgramas] = useState([]);     
    const [programasDisponibles, setProgramasDisponibles] = useState([]);
    const [inscripciones, setInscripciones] = useState([]);
    const [inscripcionSeleccionada, setInscripcionSeleccionada] = useState("");
    const [grupos, setGrupos] = useState([]);
    const [gestiones, setGestiones] = useState([]);
    const [grupoSeleccionado, setGrupoSeleccionado] = useState("");
    const [fotoPerfil, setFotoPerfil] = useState(null);
    const [infoCarrera, setInfoCarrera] = useState({});
    const [loadingGrupos, setLoadingGrupos] = useState(false)
    const [selectedItems, setSelectedItems] = useState([]);
    const [metodo_pago, setMetodo_pago]= useState("");
    const [openCapacitacionModal, setOpenCapacitacionModal] = useState(false);
    const [openCarreraModal, setOpenCarreraModal] = useState(false);
    const [estudianteSeleccionado, setEstudianteSeleccionado] = useState(null);
    const [fotoPreview, setFotoPreview] = useState(null);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const [openListaModal, setOpenListaModal] = useState(false);
    const [pensumsDisponibles, setPensumsDisponibles] = useState([]);
    const [otrosCobros, setOtrosCobros] = useState([]);
    const [loadingPensum, setLoadingPensum] = useState(false);
    const [grupoGestionSemestres, setGrupoGestionSemestre] = useState([]);
    const [semestres, setSemestres] = useState([]);
    const [selectedSemestre, setSelectedSemestre] = useState("");
    const { mostrarAlerta } = useAlerta();
    const token = sessionStorage.getItem("access_token");
    const [modoEdicion, setModoEdicion] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const obtenerInscripciones = async (usuarioId) => {
      try {
          const res = await fetch(
              `${process.env.REACT_APP_API_URL}/usuarios/${usuarioId}/inscripciones`,
              {
                  headers: {
                      Authorization: `Bearer ${token}`,
                      Accept: "application/json",
                  },
              }
          );

          const data = await res.json();

          setInscripciones(data);
          return data;

      } catch (error) {
          console.error(error);
          setInscripciones([]);
      }
  };

    const fetchSemestres = async (tipo, id) => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/semestre/${tipo}/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );

        const data = await res.json();

        const lista = Array.isArray(data.data) ? data.data : data;

        setSemestres(lista || []);

        if (tipo === "capacitacion" && lista.length > 0) {
          setEditEstudiante(prev => ({
            ...prev,
            semestre_id: lista[0].id
          }));
        }
      } catch (error) {
        console.error(error);
        setSemestres([]);
      }
    };
    const fetchGestiones = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/gestiones`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        const data = await res.json();
        setGestiones(Array.isArray(data) ? data : data.data || []);

      } catch (error) {
        console.error(error);
        setGestiones([]);
      }
    };

    
    const gruposGestionSemestre = (gestion_id,semestre_id) => {
      
      fetch(`${process.env.REACT_APP_API_URL}/semestre/${gestion_id}/${semestre_id}`,{
        headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
      })
      .then((res) => res.json())
      .then((data) => {
        const lista = Array.isArray(data.data) ? data.data : data;
        setGrupoGestionSemestre(lista || []);
      })
      .catch((err)=>{
        console.error(err);
        setGrupoGestionSemestre([]);
      });
    };
    useEffect(() => {
      fetchGestiones();
    }, []);

    const buscarPensum = async (id, tipo) => {
    if (!id) return;

    setLoadingPensum(true);
    try {
      
      // Ajustamos la ruta según el tipo de programa
      const url = tipo === "carrera" 
        ? `${process.env.REACT_APP_API_URL}/carrera/${id}/pensums` 
        : `${process.env.REACT_APP_API_URL}/capacitaciones/${id}/pensums`;

      const res = await fetch(url, {
        headers: { 
          Authorization: `Bearer ${token}`,
          Accept: "application/json"
        }
      });

      const data = await res.json();
      // Guardamos la lista de pensums (ajusta 'data.pensums' según tu API)
      setPensumsDisponibles(data.pensums || data || []);
      
    } catch (error) {
      console.error("Error al buscar pensums:", error);
      setPensumsDisponibles([]);
    } finally {
      setLoadingPensum(false);
    }
  };

    useEffect(() => {
  const fetchCatalogos = async () => {
    try {
      const token = sessionStorage.getItem("access_token");

      const res = await fetch(`${process.env.REACT_APP_API_URL}/catalogos`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const data = await res.json();

      setCarreras(data.carreras || []);
      setCapacitaciones(data.capacitaciones || []);
      setItems(data.items || []);

    } catch (error) {
      console.error(error);
    }
  };

  fetchCatalogos();
}, []);
    
    const [ui, setUi] = useState({
      loading: true,
      isSaving: false,
      open: false,
      page: 1,
    });
  useEffect(() => {
    setUi(prev => ({ ...prev, loading: false }));
  }, []);
  useEffect(() => {
    return () => {
      if (fotoPreview && fotoPreview.startsWith('blob:')) {
        URL.revokeObjectURL(fotoPreview);
      }
    };
  }, [fotoPreview]);
const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    setEditEstudiante({ ...editEstudiante, foto_perfil: file });
    // Generamos la URL una sola vez aquí
    const url = URL.createObjectURL(file);
    setFotoPreview(url);
  }
};
    

    const [editEstudiante, setEditEstudiante] = useState({
      
    id: '', // id de inscripción (si edita)

      // Datos del usuario (nuevo)
      name: '',
      codigo_estudiante: codigo,
      apellido_paterno: '',
      apellido_materno: '',
      ci: '',
      expedido: '',
      fecha_cumpleaños: '',
      celular: '',
      email: '',
      password: '',
      foto_perfil: null,
      codigo: codigo,
      tipo_sangre: '',
      lugar_nacimiento:'',
      lugar_otro:'',
      pais:'',
      pais_otro:'',
      departamento:'',
      titulo_bachiller: false,
      certificado_nacimiento: false,
      ci_entregado: false,
      convalidacion: false,
      titulo_tecnico_medio: false,
      otro_documento_convalidacion: "",
      provincia:'',
      semestre_id:'',


      // Datos de inscripción
      capacitacion_id: '',
      carrera_id: '',
      grupo_id: '',
      gestion: '',
      fecha_inscripcion: new Date().toISOString().slice(0, 10),
      nit_ci: '',
      estado: 'activo',
      tipoPrograma: '',

      monto_pago: '',
      concepto_pago: '',
      fecha_pago: new Date().toISOString().slice(0, 10),
      metodo_pago: '',
      monto_qr: '',
      monto_efectivo:'',
      //datos del perfil estudiante
      instituto:'',
      celular_referencia:'',
      referencia_nombre:'',
      referencia_relacion:'',
      como_se_entero:'',
      responsable_inscripcion:usuario.name,
      observaciones:'',
      a_nombre_factura:'',
      grupoSeleccionado: "",
      matricula_costo: '',
      matricula_pagado: '',
      matricula_descuento: '',
      mensualidad_costo: '',
      mensualidad_pagado: '',
      mensualidad_descuento: '',
      otros_cobros: [],
      numero_cuotas: "",
    });
    
    
    
    const validarPorPaso = () => {
      const allErrors = validarEstudiante(editEstudiante);

      switch(step) {
        case 1: // Datos personales
          return Object.fromEntries(
            Object.entries(allErrors).filter(([key]) => 
              ["name","apellido_paterno","apellido_materno","ci","expedido","tipo_sangre","lugar_nacimiento","pais","pais_otro","provincia","celular","email","fecha_nacimiento"].includes(key)
            )
          );
        case 2: // Información adicional
          return Object.fromEntries(
            Object.entries(allErrors).filter(([key]) => 
              ["estado","celular_referencia","referencia_nombre","referencia_relacion","como_se_entero","observaciones","a_nombre_factura"].includes(key)
            )
          );
        case 3: // Inscripción
          const erroresInscripcion = Object.fromEntries(
            Object.entries(allErrors).filter(([key]) =>
              ["institucion"].includes(key)
            )
          );

          if (modoEdicion && !inscripcionSeleccionada) {
            erroresInscripcion.inscripcionSeleccionada = 
              "Debe seleccionar una inscripción";
          }

          return erroresInscripcion;
        case 4: // Pagos
          return Object.fromEntries(
            Object.entries(allErrors).filter(([key]) => ["monto_pago","concepto_pago","fecha_pago"].includes(key))
          );
        default:
          return {};
      }
    };
    const handleOpenCapacitacion = (id) => {
      setEstudianteSeleccionado(id);
      setOpenCapacitacionModal(true);
    };

    const handleCloseCapacitacion = () => {
      setOpenCapacitacionModal(false);
      setEstudianteSeleccionado(null);
    };
    const handleOpenCarrera = (estudiante) => {
      setSelectedUsuarioId(estudiante); 
      setOpenCarreraModal(true);
    };

    const handleCloseCarrera = () => {
      setOpenCarreraModal(false);
      setEstudianteSeleccionado(null);
    };
    const handleOpenLista = () => setOpenListaModal(true);
    const handleCloseLista = () => setOpenListaModal(false);
    const handleNextStep = () => {
      const stepErrors = validarPorPaso();
      setErrors(stepErrors);

      const limitePaso = modoEdicion
        ? (esRol1 ? 4 : 3)
        : 4;

      if (Object.keys(stepErrors).length === 0) {

        if (step >= limitePaso) return;

        setStep(prev => prev + 1);

      } else {
        console.log("Errores en el paso", step, stepErrors);
      }
    };
    const handlePrevStep = () => {
      setStep(step - 1);
    };

    const handleOpenKardex = (id) => {
    setKardexUserId(id);
    setKardexOpen(true);
  };
    const handleOpenPagos = (estudiante) => {
    setUsuarioId(estudiante);
    setOpenPagos(true);
    }

  const calcularTotalPagado = () => {
  const safeNumber = (val) => Number(val) || 0;

  const matricula = safeNumber(editEstudiante.matricula_pagado);
  const mensualidad = safeNumber(editEstudiante.mensualidad_pagado);

  // Sumar los otros cobros seleccionados si existen
  const otros = selectedItems
    ? selectedItems.reduce((acc, item) => {
        // Buscamos en todas las propiedades posibles que use tu frontend/backend
        const pagadoItem = safeNumber(item.monto_pagado) || safeNumber(item.pagado) || safeNumber(item.monto_pagado_total);
        return acc + pagadoItem;
      }, 0)
    : 0;

  return matricula + mensualidad + otros;
};

  const calcularDeudaAcumulada = () => {
  const safeNumber = (val) => Number(val) || 0;

  // 1. Deuda de Matrícula y Mensualidad
  const deudaBase = 
    ((safeNumber(editEstudiante.matricula_costo) - safeNumber(editEstudiante.matricula_descuento)) - safeNumber(editEstudiante.matricula_pagado)) +
    ((safeNumber(editEstudiante.mensualidad_costo) - safeNumber(editEstudiante.mensualidad_descuento)) - safeNumber(editEstudiante.mensualidad_pagado));

  // 2. Deuda de Otros Items
  const deudaOtros = selectedItems
    .filter(item => {
      // Normalizamos el texto: quitamos tildes, mayúsculas y espacios
      const conceptoNormalizado = (item.concepto || "")
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, ""); // Convierte "matrícula" en "matricula"

      return conceptoNormalizado !== "matricula" && conceptoNormalizado !== "mensualidad";
    })
    .reduce((acc, item) => {
      // Usamos el fallback de las propiedades que mapeaste en `handleOpen`
      const monto = safeNumber(item.monto_total) || safeNumber(item.monto) || safeNumber(item.costo_unitario);
      const pagado = safeNumber(item.monto_pagado) || safeNumber(item.pagado) || safeNumber(item.monto_pagado_total);
      const descuento = safeNumber(item.descuento);

      const costoFinal = monto - descuento;
      const deudaDelItem = costoFinal - pagado;

      return acc + deudaDelItem;
    }, 0);

  return (deudaBase + deudaOtros).toFixed(2);
};


// Componente para cada ítem de cobro
  const CobroItem = ({ item }) => {
    const isSelected = editEstudiante.itemsSeleccionados?.includes(item.id) || false;

    const handleCheckboxChange = (checked) => {
      let seleccionados = editEstudiante.itemsSeleccionados || [];

      if (checked) {
        seleccionados = [...seleccionados, item.id];
      } else {
        seleccionados = seleccionados.filter((id) => id !== item.id);
        const montosActualizados = { ...editEstudiante.montosPagados };
        delete montosActualizados[item.id];
        setEditEstudiante({
          ...editEstudiante,
          itemsSeleccionados: seleccionados,
          montosPagados: montosActualizados,
        });
        return;
      }

      setEditEstudiante({ ...editEstudiante, itemsSeleccionados: seleccionados });
    };

    return (
      <Box display="flex" alignItems="center" mb={1}>
        <FormControlLabel
          control={
            <Checkbox checked={isSelected} onChange={(e) => handleCheckboxChange(e.target.checked)} />
          }
          label={`${item.concepto} - Bs. ${parseFloat(item.monto).toFixed(2)}`}
        />

        {isSelected && (
          <>
            <TextField
              type="number"
              size="small"
              sx={{ ml: 2, width: 120 }}
              placeholder="Monto pagado"
              value={editEstudiante.montosPagados?.[item.id] || ""}
              onChange={(e) => {
                const monto = parseFloat(e.target.value) || 0;
                setEditEstudiante({
                  ...editEstudiante,
                  montosPagados: {
                    ...editEstudiante.montosPagados,
                    [item.id]: monto,
                  },
                });
              }}
            />
            <Typography ml={2} color="error">
              Deuda: Bs. {(item.monto - (editEstudiante.montosPagados?.[item.id] || 0)).toFixed(2)}
            </Typography>
          </>
        )}
      </Box>
    );
  };
  
const gruposCache = useRef({});

  const handleClosePagos = () => {
    setOpenPagos(false);
  };
    // Carga estudiantes con sus relaciones usuario y carrera
  const fetchEstudiantes = useCallback(async (page = 1) => {
    setUi(prev => ({ ...prev, loading: true }));
    try {
      const res = await apiGet(`${process.env.REACT_APP_API_URL}/estudiantes-inscritos?page=${page}`);
      setEstudiantes(res.data);
      setTotalPages(res.last_page);
      setCurrentPage(page);
    } finally {
      setUi(prev => ({ ...prev, loading: false }));
    }
  }, []);

useEffect(() => {
  fetchEstudiantes(ui.page);
}, [ui.page]);

    const InfoCarrera = (IdSeleccionado, institucion) => {
      const endpoint =
        institucion === "INFOPRO"
          ? `${process.env.REACT_APP_API_URL}/carreras/${IdSeleccionado}/info`
          : `${process.env.REACT_APP_API_URL}/capacitacion/${IdSeleccionado}/info`;

      return apiGet(endpoint);
    };

    const handleInstitucionChange = (institucion) => {
      setEditEstudiante((prev) => ({
        ...prev,
        institucion,
        carrera_id: "",
        capacitacion_id: "",
      }));
      setGrupoSeleccionado("");
      setGrupos([]);

      if (institucion === "INFOPRO" || institucion === "CLADECORP") {
        const duracionDefault = "4"; 
        obtenerCapacitacionesFiltradas(institucion, duracionDefault);
      }
    };
    const fetchGrupos = async (semestreId, gestion) => {
      if (!semestreId || !gestion) {
        setGrupos([]);
        return;
      }

      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/grupos/semestres?semestre_id=${semestreId}&gestion=${gestion}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );

        const data = await res.json();
        const lista = Array.isArray(data.data) ? data.data : data;

        setGrupos(lista || []);

      } catch (error) {
        console.error(error);
        setGrupos([]);
      }
    };
    useEffect(() => {
      if (editEstudiante.semestre_id && editEstudiante.gestion_id) {
        fetchGrupos(editEstudiante.semestre_id, editEstudiante.gestion_id);
      }
    }, [editEstudiante.semestre_id, editEstudiante.gestion_id]);
    useEffect(() => {
      const id =
        tipoPrograma === "carrera" || tipoPrograma === "convalidacion"
          ? editEstudiante.carrera_id
          : editEstudiante.capacitacion_id;

      const tipoReal = tipoPrograma === "convalidacion" ? "carrera" : tipoPrograma;

      if (id) {
        fetchSemestres(tipoReal, id);
      }
    }, [editEstudiante.carrera_id, editEstudiante.capacitacion_id, tipoPrograma]);

    const obtenerCarrerasFiltradas = useCallback(async (tipo) => {
      const token = sessionStorage.getItem("access_token");
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/carreras/${tipo}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );
        const data = await res.json();
        setProgramasDisponibles(data || []);
        return data || [];
      } catch (error) {
        console.error("Error cargando carreras:", error);
        return [];
      }
    }, []);
    const obtenerCapacitacionesFiltradas = React.useCallback(async (inst, dur) => {
      const token = sessionStorage.getItem("access_token");
      
      if (!inst || !dur) return;

      try {
        const institutoLimpio = encodeURIComponent(inst);
        
        // 🔥 Mandamos SOLO el número (ej: "7" o "4"). Sin la palabra "meses"
        const duracionNumero = dur.match(/\d+/)?.[0] || "";

        const duracionLimpia = encodeURIComponent(duracionNumero);

        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/capacitacion/${institutoLimpio}/${duracionLimpia}`, 
          {
            headers: { 
              Authorization: `Bearer ${token}`, 
              Accept: "application/json" 
            },
          }
        );
        console.log("📡 3. Código de respuesta del servidor (Status):", res.status);

        if (!res.ok) {
          throw new Error(`Error en el servidor: ${res.status}`);
        }

        const data = await res.json();

        const arrayLimpio = data.data && Array.isArray(data.data) ? data.data : [];

        setProgramasDisponibles(arrayLimpio);

      } catch (err) { 
        console.error("Error cargando capacitaciones:", err); 
        setProgramasDisponibles([]); 
      }
    }, []);

useEffect(() => {
  let isMounted = true;

  const init = async () => {
    try {

      if (isMounted) {
        await fetchItem();

        if (!codigo) {
        fetchNextStudentCode().then(res => {
          if(isMounted) setCodigo(res);
        });
      }
      }
    } catch (err) {
      console.error("Error en init:", err);
    }
  };

  init();

  return () => { isMounted = false; }; 
}, []); 
const isItemSelected = (item) => {
  return selectedItems.some(si => 
    si.concepto?.toLowerCase().trim() === item.concepto?.toLowerCase().trim()
  );
};
const cargarDatosInscripcion = async (inscripcion) => {

    const esCarrera =
        inscripcion.tipo_programa === "carrera" ||
        inscripcion.tipo_programa === "convalidacion";


    setTipoPrograma(inscripcion.tipo_programa);


    if(esCarrera){

        setTipoCarrera(inscripcion.tipo_carrera);

        // carga carreras
        await obtenerCarrerasFiltradas(inscripcion.tipo_carrera);


        // selecciona carrera
        setEditEstudiante(prev => ({
            ...prev,
            carrera_id: inscripcion.carrera_id
        }));


        // carga semestres
        await fetchSemestres(
            "carrera",
            inscripcion.carrera_id
        );


    }else{

        setInstituto(inscripcion.instituto);
        const duracionNumero = inscripcion.duracion?.match(/\d+/)?.[0] || "";

        setDuracion(duracionNumero);


        await obtenerCapacitacionesFiltradas(
            inscripcion.instituto,
            inscripcion.duracion
        );


        setEditEstudiante(prev => ({
            ...prev,
            capacitacion_id: inscripcion.capacitacion_id
        }));


        await fetchSemestres(
            "capacitacion",
            inscripcion.capacitacion_id
        );

    }


    // finalmente llenar datos dependientes

    setEditEstudiante(prev => ({
        ...prev,

        inscripcion_id: inscripcion.id,

        semestre_id: inscripcion.semestre_id ?? "",
        gestion_id: inscripcion.gestion_id ?? "",
        grupo_id: inscripcion.grupo_id ?? "",

        fecha_inscripcion: inscripcion.fecha_inscripcion,
        tipo_inscripcion: inscripcion.tipo_inscripcion,

        nivel_actual: inscripcion.nivel_actual,

        convalidacion:Boolean(inscripcion.convalidacion),
        titulo_tecnico_medio:Boolean(inscripcion.titulo_tecnico_medio),
        titulo_bachiller:Boolean(inscripcion.titulo_bachiller),
        certificado_nacimiento:Boolean(inscripcion.certificado_nacimiento),
        ci_entregado:Boolean(inscripcion.ci_entregado),

        otro_documento_convalidacion:
            inscripcion.otro_documento_convalidacion ?? "",
    }));

};
const limpiarInscripcion = () => {

    setTipoPrograma("");
    setTipoCarrera("");
    setInstituto("");
    setDuracion("");

    setSemestres([]);
    setGrupos([]);
    setProgramasDisponibles([]);

    setEditEstudiante(prev => ({
        ...prev,

        inscripcion_id:"",
        carrera_id:"",
        capacitacion_id:"",
        semestre_id:"",
        gestion_id:"",
        grupo_id:"",

        fecha_inscripcion:"",
        estado:"",
        tipo_inscripcion:"",
        nivel_actual:"",

        convalidacion:false,
        titulo_tecnico_medio:false,
        titulo_bachiller:false,
        certificado_nacimiento:false,
        ci_entregado:false,

        otro_documento_convalidacion:""
    }));

};
  const handleSeleccionarInscripcion = async (e)=>{

    const id=e.target.value;

    setInscripcionSeleccionada(id);


    if(!id){

        limpiarInscripcion();

        return;
    }


    const inscripcion = inscripciones.find(
        i=>String(i.id)===String(id)
    );


    if(!inscripcion)return;


    await cargarDatosInscripcion(inscripcion);

};

const limpiarDatosPrograma = () => {

    setTipoPrograma("");
    setTipoCarrera("");
    setInstituto("");
    setDuracion("");

    setProgramas([]);
    setProgramasDisponibles([]);
    setSemestres([]);
    setGrupos([]);

    setSelectedSemestre("");
    setInscripcionSeleccionada("");

    setEditEstudiante(prev => ({
        ...prev,
        inscripcion_id:"",
        carrera_id:"",
        capacitacion_id:"",
        semestre_id:"",
        gestion_id:"",
        grupo_id:null
    }));

};
  const handleOpen = async (estudiante) => {
    setFotoPreview(null);
    limpiarDatosPrograma();
    
    if (estudiante) {
      setModoEdicion(true);
      const listaInscripciones = await obtenerInscripciones(estudiante.usuario_id);
      const primeraInscripcion = inscripciones[0];
      const metodos = estudiante.metodos_pago || [];
      const otrosCobros = estudiante.otros_cobros || [];

      const metodosUnicos = [...new Set(metodos.map(m => m.metodo))];

      let metodo_pago = "";
      if (metodosUnicos.length > 1) {
        metodo_pago = "MIXTO";
      } else if (metodosUnicos.length === 1) {
        metodo_pago = metodosUnicos[0];
      }

      // ================================
      // 2. SUMAR TOTALES POR METODO
      // ================================
      let totalQR = 0;
      let totalEfectivo = 0;

      metodos.forEach((m) => {
        if (m.metodo === "QR") totalQR += Number(m.monto);
        if (m.metodo === "EFECTIVO") totalEfectivo += Number(m.monto);
      });
      let matriculaQR = 0;
      let matriculaEfectivo = 0;
      let mensualidadQR = 0;
      let mensualidadEfectivo = 0;

      metodos.forEach((m) => {
        if (m.tipo === "matricula") {
          if (m.metodo === "QR") matriculaQR += Number(m.monto);
          if (m.metodo === "EFECTIVO") matriculaEfectivo += Number(m.monto);
        }

        if (m.tipo === "mensualidad") {
          if (m.metodo === "QR") mensualidadQR += Number(m.monto);
          if (m.metodo === "EFECTIVO") mensualidadEfectivo += Number(m.monto);
        }
      });
      const matriculaTotal = Number(estudiante.matricula_pagado || 0);
      const mensualidadTotal = Number(estudiante.mensualidad_pagado || 0);

      const totalOtros = (estudiante.otros_cobros || []).reduce(
        (acc, item) => acc + Number(item.monto_pagado || 0),
        0
      );

      const totalPagado = matriculaTotal + mensualidadTotal + totalOtros;
      const otrosCobrosProcesados = (estudiante.otros_cobros || []).map((item) => {
        const id = item.id;

        let qr = 0;
        let efectivo = 0;

        metodos.forEach((m) => {
          // 👇 IMPORTANTE: relacionar por descripcion o id
          if (
            m.tipo === "otro_cobro" &&
            m.descripcion === item.concepto // o usa ID si puedes mejor
          ) {
            if (m.metodo === "QR") qr += Number(m.monto);
            if (m.metodo === "EFECTIVO") efectivo += Number(m.monto);
          }
        });

        return {
          ...item,
          otro_pago_qr: qr,
          otro_pago_efectivo: efectivo,
          monto_pagado: qr + efectivo
        };
      });
      
      // ✏️ MODO EDITAR
      setEditEstudiante({
      ...estudiante,

      metodo_pago,

      // MATRÍCULA
       // MATRÍCULA
      matricula_pago_qr: matriculaQR,
      matricula_pago_efectivo: matriculaEfectivo,
      matricula_pagado: matriculaQR + matriculaEfectivo,

      // MENSUALIDAD
      mensualidad_pago_qr: mensualidadQR,
      mensualidad_pago_efectivo: mensualidadEfectivo,
      mensualidad_pagado: mensualidadQR + mensualidadEfectivo,

      otros_cobros: otrosCobrosProcesados
    });

    } 
    setErrors({});
    setStep(1);
    setOpen(true);
    if (!estudiante) {
      setModoEdicion(false);
      let nextCode = '';
      try {
        nextCode = await fetchNextStudentCode();
      } catch {
        nextCode = 'IC701';
      }
      setEditEstudiante(prev => ({
        ...prev,
        id: '',
        codigo: nextCode,
        codigo_estudiante:nextCode,
        fecha_cumpleaños: '',
        fecha_inscripcion: new Date().toLocaleDateString('en-CA'),
        responsable_inscripcion: estudiante?.responsable_inscripcion || usuario?.name || "",
        montosPagados: {},
        matricula_costo: '',
        matricula_pagado: '',
        mensualidad_costo: '',
        mensualidad_pagado: '',
        metodo_pago: '',
      }));
      setSelectedItems([])
      return;
    }

    setEditEstudiante(prev => ({
      ...prev,
      id: estudiante.usuario_id || '',
      name: estudiante.name || '',
      apellido_paterno: estudiante.apellido_paterno || '',
      apellido_materno: estudiante.apellido_materno || '',
      ci: estudiante.ci || '',
      expedido: estudiante.expedido || '',
      celular: estudiante.celular || '',
      email: estudiante.email || '',
      semestre_id: estudiante.semestre_id || estudiante.cap_semestre_id || '',
      gestion_id: estudiante.gestion_id || estudiante.cap_gestion_id || '',
      grupo_id: estudiante.grupo_id || estudiante.cap_grupo_id || '',
      fecha_cumpleaños: estudiante.fecha_cumpleaños || '',
      codigo: estudiante.codigo || '',
      tipo_sangre: estudiante.tipo_sangre || '',
      lugar_nacimiento: estudiante.lugar_nacimiento || '',
      lugar_otro: estudiante.lugar_nacimiento || '',
      pais: estudiante.pais || '',
      pais_otro: estudiante.pais || '',
      departamento: estudiante.departamento || '',
      fecha_inscripcion: estudiante.fecha_inscripcion_carrera || estudiante.fecha_inscripcion_capacitacion,
      nit_ci: estudiante.nit_ci || '',
      provincia: estudiante.provincia || '',
      estado: estudiante.estado_inscripcion,
      responsable_inscripcion: estudiante.responsable_inscripcion || usuario.name,
      foto_perfil: estudiante.foto_perfil || null,
      celular_referencia: estudiante.celular_referencia || '',
      referencia_nombre: estudiante.referencia_nombre || '',
      referencia_relacion: estudiante.referencia_relacion || '',
      como_se_entero: estudiante.como_se_entero || '',
      observaciones: estudiante.observaciones || '',
      a_nombre_factura: estudiante.a_nombre_factura || '',
      matricula_costo: estudiante.matricula_costo || 0,
      mensualidad_costo: estudiante.mensualidad_costo || 0,
      numero_cuotas: estudiante.numero_cuotas || 0,
      mensualidad_inicial_pagado: estudiante.mensualidad_inicial_pagado || 0,
      otros_cobros: prev.otros_cobros,
      titulo_bachiller: Boolean(Number(estudiante.titulo_bachiller)),
      certificado_nacimiento: Boolean(Number(estudiante.certificado_nacimiento)),
      ci_entregado: Boolean(Number(estudiante.ci_entregado)),
      convalidacion: Boolean(Number(estudiante.convalidacion)),
      titulo_tecnico_medio: Boolean(Number(estudiante.titulo_tecnico_medio)),
      otro_documento_convalidacion: estudiante.otro_documento_convalidacion || '',
    }));
    
  };
  
  const maxStep = modoEdicion
    ? (esRol1 ? 4 : 3)
    : 4;
  const completed = modoEdicion
  ? {
      0: step > 1,
      1: step > 2,
      2: step > 3,
    }
  : {
      0: step > 1,
      1: step > 2,
      2: step > 3,
      3: step > 4,
      4: false,
    };
  useEffect(() => {
  if (editEstudiante) {
    setSelectedItems(editEstudiante.otros_cobros || []);
  }
}, [editEstudiante]);


    const handleClose = () => {
      setOpen(false);
      setEditEstudiante({
        id: '',
        carrera_id: '',
        fecha_inscripcion: '',
        estado: ''
      });
      setTipoPrograma('');
      setTipoCarrera('');
      setInstituto('');
      setDuracion('');
      setCodigo('');
      setProgramas([]);
    };

    const handleCelularChange = (e) => {
      const value = e.target.value;

      // solo números
      if (/^\d*$/.test(value)) {
        setEditEstudiante({
          ...editEstudiante,
          celular_referencia: value,
        });
      }
    };
    const handleChange = useCallback((e) => {
      const { name, value, type } = e.target;
      const val = type === 'number' ? Number(value) : value;

      setEditEstudiante(prev => {
        if (prev[name] === val) return prev;
        return { ...prev, [name]: val };
      });
    }, []);

const debouncedFiltrar = useCallback(
  _.debounce((inst, dur) => {
    obtenerCapacitacionesFiltradas(inst, dur);
  }, 500), 
  []
);
    const handleDeleteEstudiante = async (id) => {
    const confirmacion = window.confirm("¿Estás seguro de que deseas eliminar este estudiante?");
    if (!confirmacion) return;
    const token = sessionStorage.getItem("access_token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/estudiante/${id}/eliminar-logico`, {
        method: "PUT", // o "DELETE" si usas delete lógico con DELETE
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!response.ok) throw new Error("Error al eliminar el estudiante");

      alert("Estudiante eliminado con éxito.");
      window.location.reload();

    } catch (error) {
      console.error("Error eliminando estudiante:", error);
      alert("Hubo un error al eliminar el estudiante.");
    }
  };
const calcularMetodoPago = (data, selectedItems) => {
  let metodos = new Set();

  // MATRÍCULA
  if ((data.matricula_pago_qr ?? 0) > 0) metodos.add("QR");
  if ((data.matricula_pago_efectivo ?? 0) > 0) metodos.add("EFECTIVO");

  // MENSUALIDAD
  if ((data.mensualidad_pago_qr ?? 0) > 0) metodos.add("QR");
  if ((data.mensualidad_pago_efectivo ?? 0) > 0) metodos.add("EFECTIVO");

  // OTROS COBROS
  selectedItems.forEach(item => {
    if ((item.otro_pago_qr ?? 0) > 0) metodos.add("QR");
    if ((item.otro_pago_efectivo ?? 0) > 0) metodos.add("EFECTIVO");
  });

  if (metodos.size > 1) return "MIXTO";
  if (metodos.size === 1) return [...metodos][0];
  return "";
};
  const handleSaveEstudiante = async () => {
    setUi((prev) => ({ ...prev, isSaving: true }));
    try {
      const token = sessionStorage.getItem("access_token");
      if (!token) throw new Error("No hay token de sesión. Inicia sesión de nuevo.");

      const url = editEstudiante.id
        ? `${process.env.REACT_APP_API_URL}/inscripciones/${editEstudiante.id}`
        : `${process.env.REACT_APP_API_URL}/inscripciones`;

      const isUpdate = !!editEstudiante.id;
      const method = "POST"; // Laravel prefiere POST para FormData con imágenes

      // 1. Mapeamos otros cobros (ahora con su respectivo QR y Efectivo si es mixto)
      const itemsParaEnviar = selectedItems.map((item) => ({
        id: item.id,
        concepto: item.concepto,
        codigo_estudiante: editEstudiante.codigo,
        monto_total: Number(item.monto_total) || Number(item.monto) || 0,
        descuento: Number(item.descuento) || 0,
        fecha_pago: editEstudiante.fecha_pago,
        grupo_id: editEstudiante.grupo_id,
        responsable_inscripcion: usuario?.name || "",
        numero_cuotas_otros_cobros: item.tipo_cobro === "mensual" ? item.numero_cuotas_otros_cobros : 1,
        
        // 🔥 NUEVO: Atrapamos QR y Efectivo individuales de Otros Cobros
        otro_pago_qr: editEstudiante.metodo_pago === "MIXTO" ? Number(item.otro_pago_qr || 0) : 0,
        otro_pago_efectivo: editEstudiante.metodo_pago === "MIXTO" ? Number(item.otro_pago_efectivo || 0) : 0,
        monto_pagado: editEstudiante.metodo_pago === "MIXTO" 
          ? Number(item.otro_pago_qr || 0) + Number(item.otro_pago_efectivo || 0) 
          : Number(item.monto_pagado || 0),
      }));
      // console.log("EDIT ESTUDIANTE ANTES DE FORM DATA", editEstudiante);
      // console.log("INSCRIPCION SELECCIONADA", inscripcionSeleccionada);
      // console.log("ESTADO ANTES DE FORMDATA:", editEstudiante.estado);

      const formData = new FormData();

      if (isUpdate) formData.append("_method", "PUT");

      // 2. Adjuntamos los datos básicos del estudiante y del perfil
      for (let key in editEstudiante) {
        if (!["itemsSeleccionados", "montosPagados", "foto_perfil"].includes(key)) {
          if (editEstudiante[key] !== undefined && editEstudiante[key] !== null) {
            formData.append(key, editEstudiante[key]);
          }
        }
      }

        formData.append("matricula_pago_qr", Number(editEstudiante.matricula_pago_qr || 0));
        formData.append("matricula_pago_efectivo", Number(editEstudiante.matricula_pago_efectivo || 0));
        formData.append("mensualidad_pago_qr", Number(editEstudiante.mensualidad_pago_qr || 0));
        formData.append("mensualidad_pago_efectivo", Number(editEstudiante.mensualidad_pago_efectivo || 0));


      // 4. Adjuntamos la lista de "Otros cobros" mapeando sus QR/Efe internos
      itemsParaEnviar.forEach((item, index) => {
        formData.append(`items[${index}][id]`, item.id);
        formData.append(`items[${index}][concepto]`, item.concepto);
        formData.append(`items[${index}][monto_total]`, item.monto_total);
        formData.append(`items[${index}][monto_pagado]`, item.monto_pagado);
        formData.append(`items[${index}][descuento]`, item.descuento);
        formData.append(`items[${index}][fecha_pago]`, item.fecha_pago);
        formData.append(`items[${index}][grupo_id]`, item.grupo_id);
        formData.append(`items[${index}][responsable_inscripcion]`, item.responsable_inscripcion);
        formData.append(`items[${index}][numero_cuotas_otros_cobros]`, item.numero_cuotas_otros_cobros ?? 1);
        
        // 🔥 Atrapamos los QR/Efectivo de cada Item
        formData.append(`items[${index}][otro_pago_qr]`, item.otro_pago_qr);
        formData.append(`items[${index}][otro_pago_efectivo]`, item.otro_pago_efectivo);
      });

      const tipoProgramaFinal = tipoPrograma === "convalidacion" ? "carrera" : tipoPrograma;
      formData.append("tipoPrograma", tipoProgramaFinal);


      if (editEstudiante.foto_perfil instanceof File) {
        formData.append("foto_perfil", editEstudiante.foto_perfil);
      }

      // console.log("========== FORMDATA ==========");

      // for (const [key, value] of formData.entries()) {
      //   console.log(`${key}:`, value);
      // }

      // console.log("================================")

      const response = await fetch(url, {
        method: "POST", // Se deja en POST por el FormData con archivos adjuntos
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();

        throw new Error(
          errorData.error || errorData.message || "Error al guardar la inscripción"
        );
      }

      mostrarAlerta(
        editEstudiante.id ? "Inscripción actualizada correctamente" : "Inscripción registrada correctamente",
        "success"
      );

      fetchEstudiantes();
      handleClose();
    } catch (error) {
      console.error("Fallo al guardar inscripción:", error);
      mostrarAlerta(error.message, "error");
    } finally {
      setUi((prev) => ({ ...prev, isSaving: false }));
    }
  };
  
const filteredData = useMemo(() => {
    if (!searchTerm) return estudiantes;
    const lowSearch = searchTerm.toLowerCase();
    return estudiantes.filter(item => 
      (item.name?.toLowerCase().includes(lowSearch)) ||
      (item.apellido_paterno?.toLowerCase().includes(lowSearch)) ||
      (item.ci?.toLowerCase().includes(lowSearch)) ||
      (item.codigo?.toLowerCase().includes(lowSearch))
    );
  }, [estudiantes, searchTerm]);

    if (ui.loading) return <div>Cargando estudiantes...</div>;

    return (
      <div>
        <PagosModal
          open={openPagos}
          handleClose={handleClosePagos}
          usuarioId={usuarioId}
        />
        
        <InscripcionCarreraModal
          open={openCarreraModal}
          handleClose={handleCloseCarrera}
          usuarioId={selectedUsuarioId}
          items={items}
          carreras={carreras}
        />
        <ListaModal
          open={openListaModal}
          handleClose={handleCloseLista}
          carreras={carreras}
          capacitaciones={capacitaciones}
        />
        <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
          <MDButton sx={{ ml: 2, mb: 2 }} color="success" onClick={() => handleOpen(null)}>
            Añadir Inscripción
          </MDButton>
          <MDButton sx={{ ml: 2, mb: 2 }} color="info" onClick={handleOpenLista}>
            Listas de Estudiantes
          </MDButton>
        </Box>
        

          <Table
            estudiantes={filteredData}
            handleOpen={handleOpen}
            handleDeleteEstudiante={handleDeleteEstudiante}
            handleOpenCapacitacion={handleOpenCapacitacion}
            handleOpenCarrera={handleOpenCarrera}
            handleOpenKardex={handleOpenKardex}
            handleOpenPagos={handleOpenPagos}
            onActualizado={() => fetchEstudiantes(currentPage)}
          />
          
          <Box display="flex" justifyContent="center" mt={2} gap={2} alignItems="center">
            <Button
              onClick={() => setUi(prev => ({ ...prev, page: prev.page - 1 }))}
              disabled={ui.page === 1}
            >
              Página anterior
            </Button>

            <Typography>
              Página {ui.page} de {totalPages}
            </Typography>

            <Button
              onClick={() => setUi(prev => ({ ...prev, page: prev.page + 1 }))}
            >
              Siguiente página
            </Button>
          </Box>


        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box sx={style}>
            {editEstudiante && (
              <Typography id="modal-title" variant="h6" component="h2" mb={2}>
                {editEstudiante.id ? "Editar Inscripción" : "Nueva Inscripción"}
              </Typography>
            )}
            <Stepper activeStep={step - 1} alternativeLabel>
              {steps.map((label, index) => (
                <Step key={label} completed={completed[index]}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            {/* ---------------------- PÁGINA 1: DATOS DEL ESTUDIANTE ---------------------- */}
           {step === 1 && (
              <>
                <Typography variant="h6" fontWeight="bold" mb={2}>
                  Datos del Estudiante
                </Typography>

                <input
                  type="hidden"
                  name="responsable_inscripcion_id"
                  value={usuario?.id || ""}
                />

                <Grid container spacing={2}>

                  {/* FOTO */}
                  <Grid item xs={12} md={3} textAlign="center">
                    <Avatar
                      src={
                        fotoPreview ||
                        (typeof editEstudiante.foto_perfil === "string"
                          ? `${BASE_URL}/storage/${editEstudiante.foto_perfil}`
                          : "/default-avatar.jpg")
                      }
                      sx={{ width: 120, height: 120, margin: "auto", mb: 1 }}
                    />

                    <Button variant="contained" size="small" component="label">
                      Cambiar foto
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0];

                          if (file) {
                            setEditEstudiante({
                              ...editEstudiante,
                              foto_perfil: file,
                            });

                            setFotoPreview(URL.createObjectURL(file)); // 🔥 ESTA ES LA CLAVE
                          }
                        }}
                      />
                    </Button>
                  </Grid>

                  {/* DATOS */}
                  <Grid item xs={12} md={9}>
                    <Grid container spacing={2}>

                      {/* Nombre */}
                      <Grid item xs={12} md={4}>
                        <TextField
                          label="Nombre"
                          fullWidth
                          name="name"
                          value={editEstudiante.name}
                          onChange={handleChange}
                          error={Boolean(errors.name)}
                          helperText={errors.name}
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <TextField
                          label="Apellido Paterno"
                          fullWidth
                          name="apellido_paterno"
                          value={editEstudiante.apellido_paterno || ""}
                          onChange={handleChange}
                          error={Boolean(errors.apellido_paterno)}
                          helperText={errors.apellido_paterno}
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <TextField
                          label="Apellido Materno"
                          fullWidth
                          name="apellido_materno"
                          value={editEstudiante.apellido_materno || ""}
                          onChange={handleChange}
                          error={Boolean(errors.apellido_materno)}
                          helperText={errors.apellido_materno}
                        />
                      </Grid>

                      {/* Documento */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          label="CI"
                          fullWidth
                          name="ci"
                          value={editEstudiante.ci}
                          onChange={handleChange}
                          error={Boolean(errors.ci)}
                          helperText={errors.ci}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          select
                          label="Expedido"
                          fullWidth
                          name="expedido"
                          value={editEstudiante.expedido || ""}
                          onChange={handleChange}
                          SelectProps={{ native: true }}
                          error={Boolean(errors.expedido)}
                          helperText={errors.expedido}
                        >
                          <option value=""></option>
                          <option value="CB">Cochabamba</option>
                          <option value="LP">La Paz</option>
                          <option value="SC">Santa Cruz</option>
                          <option value="TJ">Tarija</option>
                          <option value="OR">Oruro</option>
                          <option value="PT">Potosí</option>
                          <option value="CH">Chuquisaca</option>
                          <option value="BE">Beni</option>
                          <option value="PD">Pando</option>
                        </TextField>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          type="date"
                          label="Fecha Nacimiento"
                          name="fecha_cumpleaños"
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          value={editEstudiante.fecha_cumpleaños}
                          error={Boolean(errors.fecha_nacimiento)}
                          helperText={errors.fecha_nacimiento}
                          onChange={(e) =>
                            setEditEstudiante({
                              ...editEstudiante,
                              fecha_cumpleaños: e.target.value,
                            })
                          }
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          select
                          label="Tipo de Sangre"
                          fullWidth
                          name="tipo_sangre"
                          value={editEstudiante.tipo_sangre || ""}
                          onChange={handleChange}
                          error={Boolean(errors.tipo_sangre)}
                          helperText={errors.tipo_sangre}
                          SelectProps={{ native: true }}
                        >
                          <option value=""></option>
                          <option value="NO_CONOCE">No conoce</option>
                          <option value="A+">A+</option>
                          <option value="A-">A-</option>
                          <option value="B+">B+</option>
                          <option value="B-">B-</option>
                          <option value="AB+">AB+</option>
                          <option value="AB-">AB-</option>
                          <option value="O+">O+</option>
                          <option value="O-">O-</option>
                        </TextField>
                      </Grid>

                      {/* Lugar nacimiento */}
                      <Grid item xs={12} md={6}>
                        <Box sx={{ display: "flex" }}>
                        <TextField
                          select
                          label="Lugar de Nacimiento"
                          fullWidth
                          name="lugar_nacimiento"
                          value={editEstudiante.lugar_nacimiento || ""}
                          error={Boolean(errors.lugar_nacimiento)}
                          helperText={errors.lugar_nacimiento}
                          onChange={handleChange}
                          SelectProps={{ native: true }}
                          sx={{
                              width: "40%",
                              "& .MuiOutlinedInput-root": {
                                borderTopRightRadius: 0,
                                borderBottomRightRadius: 0
                              }
                            }}
                        >
                          <option value=""></option>
                          <option value="COCHABAMBA">Cochabamba</option>
                          <option value="LA PAZ">La Paz</option>
                          <option value="SANTA CRUZ">Santa Cruz</option>
                          <option value="TARIJA">Tarija</option>
                          <option value="ORURO">Oruro</option>
                          <option value="POTOSI">Potosí</option>
                          <option value="CHUQUISACA">Chuquisaca</option>
                          <option value="BENI">Beni</option>
                          <option value="PANDO">Pando</option>
                          <option value="OTROS">Otros</option>
                        </TextField>
                        <TextField
                          label="Especificar lugar"
                          name="lugar_otro"
                          value={editEstudiante.lugar_otro || ""}
                          onChange={handleChange}
                          error={Boolean(errors.lugar_otro)}
                          helperText={errors.lugar_otro}
                          disabled={editEstudiante.lugar_nacimiento !== "OTROS"}
                          fullWidth
                          sx={{
                              width: "60%",
                              "& .MuiOutlinedInput-root": {
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0
                              }
                            }}
                        />
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Box sx={{ display: "flex" }}>
                          
                          {/* Combo */}
                          <TextField
                            select
                            label="País"
                            name="pais"
                            value={editEstudiante.pais || ""}
                            error={Boolean(errors.pais)}
                            helperText={errors.pais}
                            onChange={handleChange}
                            SelectProps={{ native: true }}
                            fullWidth
                          >
                            <option value=""></option>
                            <option value="BOLIVIA">Bolivia</option>
                            <option value="EXTRANJEROS">Extranjeros</option>
                          </TextField>
                        </Box>
                      </Grid>
                      

                      <Grid item xs={12} md={4}>
                        <TextField
                          label="Provincia"
                          fullWidth
                          name="provincia"
                          value={editEstudiante.provincia || ""}
                          error={Boolean(errors.provincia)}
                          helperText={errors.provincia}
                          onChange={handleChange}
                        />
                      </Grid>

                      {/* Contacto */}
                      <Grid item xs={12} md={4}>
                        <TextField
                          label="Celular"
                          fullWidth
                          name="celular"
                          value={editEstudiante.celular}
                          onChange={handleChange}
                          error={Boolean(errors.celular)}
                          helperText={errors.celular}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Email"
                          fullWidth
                          name="email"
                          value={editEstudiante.email}
                          onChange={handleChange}
                          error={Boolean(errors.email)}
                          helperText={errors.email}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          key={editEstudiante.codigo}
                          label="Código Estudiante"
                          fullWidth
                          name="codigo_estudiante"
                          value={editEstudiante.codigo}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>

                    </Grid>
                  </Grid>

                </Grid>
              </>
            )}
            {step === 2 && (
              <>
                <Typography variant="h6" fontWeight="bold" mb={2}>
                  Datos de Inscripción
                </Typography>

                <Grid container spacing={2}>
                  {/* Datos automáticos */}
                  <Grid item xs={6}>
                    <TextField
                      type="date"
                      label="Fecha Inscripción"
                      fullWidth
                      name="fecha_inscripcion"
                      value={editEstudiante.fecha_inscripcion}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ readOnly: true }}
                      error={Boolean(errors.fecha_inscripcion)}
                      helperText={errors.fecha_inscripcion}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      label="Responsable de la inscripción"
                      fullWidth
                      name="responsable_inscripcion"
                      value={editEstudiante.responsable_inscripcion ?? editEstudiante.name}
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>

                  {/* Contacto de referencia */}
                  <Grid item xs={4}>
                    <TextField
                      label="Celular de referencia"
                      fullWidth
                      name="celular_referencia"
                      value={editEstudiante.celular_referencia}
                      onChange={handleCelularChange}
                      error={Boolean(errors.celular_referencia)}
                      helperText={errors.celular_referencia}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      label="Nombre de referencia"
                      fullWidth
                      name="referencia_nombre"
                      value={editEstudiante.referencia_nombre}
                      onChange={handleChange}
                      error={Boolean(errors.referencia_nombre)}
                      helperText={errors.referencia_nombre}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      label="Relación con la persona"
                      fullWidth
                      name="referencia_relacion"
                      value={editEstudiante.referencia_relacion}
                      onChange={handleChange}
                      error={Boolean(errors.referencia_relacion)}
                      helperText={errors.referencia_relacion}
                    />
                  </Grid>

                  {/* Datos administrativos */}
                  <Grid item xs={6}>
                    <TextField
                      label="Nombre para la factura"
                      fullWidth
                      name="a_nombre_factura"
                      value={editEstudiante.a_nombre_factura}
                      onChange={handleChange}
                      error={Boolean(errors.a_nombre_factura)}
                      helperText={errors.a_nombre_factura}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label="NIT / CI"
                      fullWidth
                      name="nit_ci"
                      value={editEstudiante.nit_ci || ""}
                      onChange={handleChange}
                      error={Boolean(errors.nit_ci)}
                      helperText={errors.nit_ci}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      select
                      fullWidth
                      label="¿Cómo se enteró?"
                      name="como_se_entero"
                      value={editEstudiante.como_se_entero || ""}
                      SelectProps={{ native: true }} // Usamos el select nativo para mejor rendimiento
                      onChange={(e) =>
                        setEditEstudiante((prev) => ({
                          ...prev,
                          como_se_entero: e.target.value,
                        }))
                      }
                    >
                      <option value=""></option>
                      <option value="FACEBOOK">Facebook</option>
                      <option value="TIK TOK">Tik tok</option>
                      <option value="LETRERO">Letrero</option>
                      <option value="REFERENCIA">Referencia</option>
                      <option value="VOLANTE O AFICHE">Volante o afiche</option>
                      <option value="OTROS">Otros</option>
                    </TextField>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Observaciones"
                      fullWidth
                      name="observaciones"
                      value={editEstudiante.observaciones}
                      onChange={handleChange}
                      error={Boolean(errors.observaciones)}
                      helperText={errors.observaciones}
                    />
                  </Grid>

                  {/* Estado */}
                  <Grid item xs={12}>
                    <TextField
                      select
                      label="Estado"
                      fullWidth
                      name="estado"
                      value={editEstudiante.estado}
                      onChange={handleChange}
                      SelectProps={{ native: true }}
                      error={Boolean(errors.estado)}
                      helperText={errors.estado}
                    >
                      <option value=""></option>
                      <option value="activo">Activo</option>
                      <option value="inactivo">Inactivo</option>
                      <option value="abandonado">Abandonado</option>
                      <option value="finalizado">Finalizado</option>
                    </TextField>
                  </Grid>
                  {/* DOCUMENTOS */}
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" fontWeight="bold" mt={2}>
                      Documentación entregada
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={Boolean(editEstudiante?.titulo_bachiller)}
                          onChange={(e) =>
                            setEditEstudiante({
                              ...editEstudiante,
                              titulo_bachiller: e.target.checked,
                            })
                          }
                        />
                      }
                      label="Título de Bachiller"
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={Boolean(editEstudiante?.certificado_nacimiento)}
                          onChange={(e) =>
                            setEditEstudiante({
                              ...editEstudiante,
                              certificado_nacimiento: e.target.checked,
                            })
                          }
                        />
                      }
                      label="Certificado de Nacimiento"
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={Boolean(editEstudiante?.ci_entregado)}
                          onChange={(e) =>
                            setEditEstudiante({
                              ...editEstudiante,
                              ci_entregado: e.target.checked,
                            })
                          }
                        />
                      }
                      label="Fotocopia de carnet de identidad"
                    />
                  </Grid>
                </Grid>
              </>
            )}
            {step === 3 && (
              <>
                <Typography variant="h6" fontWeight="bold" mb={2}>
                  Selección del Programa
                </Typography>
                {modoEdicion && (
                  <TextField
                      select
                      fullWidth
                      label="Inscripción"
                      value={String(inscripcionSeleccionada || "")}
                      onChange={handleSeleccionarInscripcion}
                      SelectProps={{ native: true }}
                      error={Boolean(errors.inscripcionSeleccionada)}
                      helperText={errors.inscripcionSeleccionada || ""}
                      sx={{ mb: 2 }}
                  >
                      <option value=""></option>

                      {inscripciones.map((i)=>(
                          <option key={i.id} value={String(i.id)}>
                              {`${i.programa} | ${i.tipo_inscripcion} | Gestión ${i.gestion} | ${i.semestre} | Grupo ${i.grupo ?? "Sin grupo"}`}
                          </option>
                      ))}
                  </TextField>
                )}

                {/* Tipo de programa */}
                <TextField
                  select
                  fullWidth
                  label="Tipo de programa"
                  value={tipoPrograma}
                  SelectProps={{ native:true }}
                  onChange={(e) => {
                    const valor = e.target.value;
                    setTipoPrograma(valor);
                    setTipoCarrera("");
                    setDuracion("");
                    setInstituto("");
                    setProgramas([]);

                    setSemestres([]);
                    setGrupos([]);
                    setProgramasDisponibles([]);
                    setSelectedSemestre("");

                    setEditEstudiante(prev => ({
                      ...prev,
                      carrera_id: null,
                      capacitacion_id: null,
                      semestre_id: null,
                      gestion_id: null,
                      grupo_id: null,
                      instituto: "",
                      titulo_tecnico_medio: false,
                      convalidacion: false,
                    }));
                  }}
                  sx={{ mb: 2 }}
                >
                  <option value=""></option>
                  <option value="carrera">Carrera</option>
                  <option value="capacitacion">Capacitación</option>
                  <option value="convalidacion">Convalidación</option>
                </TextField>

                {/* Tipo de carrera */}
                {(tipoPrograma === "carrera" || tipoPrograma === "convalidacion") && (
                  <TextField
                    select
                    fullWidth
                    label="Tipo de carrera"
                    value={tipoCarrera}
                    onChange={(e) => {
                      const valor = e.target.value;
                      setTipoCarrera(valor);
                      obtenerCarrerasFiltradas(valor);
                      setEditEstudiante(prev => ({
                        ...prev,
                        carrera_id: null,
                        grupo_id: null,
                      }));
                    }}
                    SelectProps={{ native: true }}
                    sx={{ mb: 2 }}
                  >
                    <option value=""></option>
                    <option value="anual">Anual</option>
                    <option value="semestral">Semestral</option>
                  </TextField>
                  
                )}
                
                

                {/* Instituto para capacitación */}
                {tipoPrograma === "capacitacion" && (
                  <TextField
                    select
                    fullWidth
                    label="Instituto"
                    value={instituto}
                    SelectProps={{ native: true }}
                    onChange={(e) => {
                      const valor = e.target.value;
                      setInstituto(valor);
                      setDuracion("");
                      setProgramas([]);
                      setEditEstudiante(prev => ({
                        ...prev,
                        instituto: valor,
                        capacitacion_id: null,
                        grupo_id: null,
                      }));
                    }}
                    sx={{ mb: 2 }}
                  >
                    <option value=""></option>
                    <option value="INFOPRO">INFOPRO</option>
                    <option value="CLADECORP">CLADECORP</option>
                  </TextField>
                )}

                {/* Duración */}
                {(instituto === "INFOPRO" || instituto === "CLADECORP") && (
                  <TextField
                    select
                    fullWidth
                    label="Duración"
                    value={duracion}
                    SelectProps={{ native: true }}
                    onChange={(e) => {
                      const valor = e.target.value;
                      setDuracion(valor);
                      if (instituto && valor) {
                        obtenerCapacitacionesFiltradas(instituto, valor);
                      }
                      setEditEstudiante(prev => ({
                        ...prev,
                        capacitacion_id: null,
                        grupo_id: null,
                      }));
                    }}
                    sx={{ mb: 2 }}
                  >
                    <option value=""></option>
                    {instituto === "INFOPRO" && (
                      <>
                        <option value="3">3 meses</option>
                        <option value="7">7 meses</option>
                      </>
                    )}
                    {instituto === "CLADECORP" && (
                      <>
                        <option value="1">1 mes</option>
                        <option value="3">3 meses</option>
                        <option value="7">7 meses</option>
                      </>
                    )}
                  </TextField>
                )}

                {/* Selección del programa (Carrera o Capacitación) */}
                <Grid container spacing={2}>
                  <Grid container spacing={2} p={2}>
                    <Grid item xs={12} md={4}>
                      <TextField
                        select
                        fullWidth
                        label={tipoPrograma === "carrera" || tipoPrograma === "convalidacion"
                          ? "Seleccionar carrera"
                          : "Seleccionar curso"}
                        value={
                          tipoPrograma === "carrera" || tipoPrograma === "convalidacion"
                            ? editEstudiante.carrera_id ?? ""
                            : editEstudiante.capacitacion_id ?? ""
                        }
                        onChange={(e) => {
                          const id = e.target.value ? Number(e.target.value) : null;
                          const tipoReal = tipoPrograma === "convalidacion" ? "carrera" : tipoPrograma;

                          setEditEstudiante(prev => ({
                            ...prev,
                            carrera_id: (tipoPrograma === "carrera" || tipoPrograma === "convalidacion") ? id : prev.carrera_id,
                            capacitacion_id: tipoPrograma === "capacitacion" ? id : prev.capacitacion_id,
                            grupo_id: null,
                          }));

                          setSemestres([]);
                          setSelectedSemestre("");

                          if (id) {
                            fetchSemestres(tipoReal, id);
                          }
                        }}
                        SelectProps={{ native: true }}
                      >
                        <option value=""></option>
                        {programasDisponibles.map((prog) => (
                          <option key={prog.id} value={prog.id}>
                            {prog.nombre}
                          </option>
                        ))}
                      </TextField>
                    </Grid>

                    {/* SEMESTRE */}
                    {tipoPrograma !== "capacitacion" && (
                    <Grid item xs={12} md={4}>
                      <TextField
                        select
                        fullWidth
                        label="Semestre/Año/Módulo"
                        value={editEstudiante.semestre_id?.toString() || ""}
                        onChange={(e) => {
                          const val = e.target.value;

                          setSelectedSemestre(val);

                          setEditEstudiante(prev => ({
                            ...prev,
                            semestre_id: val
                          }));
                        }}
                        SelectProps={{ native: true }}
                      >
                        <option value=""></option>
                        {semestres.map(s => (
                          <option key={s.id} value={s.id}>
                            {s.nombre} {s.numero}
                          </option>
                        ))}
                      </TextField>
                    </Grid>
                  )}

                    {/* GESTIÓN */}
                    <Grid item xs={12} md={4}>
                      <TextField
                        select
                        fullWidth
                        label="Gestión"
                        value={editEstudiante.gestion_id || ""}
                        onChange={(e) => {
                          const val = e.target.value;

                          setEditEstudiante(prev => ({
                            ...prev,
                            gestion_id: val,
                            grupo_id: null
                          }));
                        }}
                        SelectProps={{ native: true }}
                      >
                        <option value=""></option>
                        {gestiones.map(g => (
                          <option key={g.id} value={g.id}>
                            {g.nombre}
                          </option>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                  <Grid>
                    {tipoPrograma === "convalidacion" && (
                      <Box sx={{ ml: 2, mb: 2 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={editEstudiante.titulo_tecnico_medio || false}
                              onChange={(e) =>
                                setEditEstudiante(prev => ({
                                  ...prev,
                                  titulo_tecnico_medio: e.target.checked,
                                  convalidacion: true, // 👈 importante
                                }))
                              }
                            />
                          }
                          label="Título Técnico Medio"
                        />
                      </Box>
                    )}
                  </Grid>

                  {/* Grupo */}
                  <Grid xs={12}>
                    <Box sx={{ ml: 2, mt: 0.5 }}>
                      {loadingGrupos ? (
                        <CircularProgress size={24} sx={{ mb: 3 }} />
                      ) : (
                        <TextField
                          select
                          fullWidth
                          label="Grupo"
                          name="grupo_id"
                          value={editEstudiante.grupo_id || ""}
                          SelectProps={{ native: true }}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) =>
                            setEditEstudiante(prev => ({
                              ...prev,
                              grupo_id: e.target.value ? Number(e.target.value) : null,
                            }))
                          }
                        >
                          <option value=""></option>
                          {grupos.length > 0 ? (
                            grupos.map((grupo) => {
                              const grupoLleno = Number(grupo.cupo_maximo) === 0;
                              return (
                                <option key={grupo.id} value={grupo.id} disabled={grupoLleno}>
                                  {grupo.nombre} ({grupo.turno}, {grupo.dias})
                                  {grupoLleno ? " (GRUPO LLENO)" : ""}
                                </option>
                              );
                            })
                          ) : (
                            <option value="" disabled>No hay grupos disponibles</option>
                          )}
                        </TextField>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </>
            )}
            {step === 4 && (
              <Box sx={{ maxWidth: 800, mx: "auto", p: 2 }}>
                <Typography variant="h5" fontWeight="bold" mb={3} color="primary">
                  Datos de Pago e Inscripción
                </Typography>

                {/* ==========================================
                    1️⃣ CONFIGURACIÓN GLOBAL DEL MÉTODO DE PAGO
                    (Se subió aquí para que la tabla sepa qué inputs mostrar)
                    ========================================== */}
                <Paper variant="outlined" sx={{ p: 3, mb: 4, borderRadius: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                    Configuración de Pago y Plan
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        select
                        fullWidth
                        SelectProps={{ native: true }}
                        value={editEstudiante.metodo_pago || ""}
                        label="Método de pago"
                        name="metodo_pago"
                        onChange={(e) =>
                          setEditEstudiante((prev) => ({
                            ...prev,
                            metodo_pago: e.target.value,
                          }))
                        }
                      >
                        <option value=""></option>
                        <option value="QR">Pago por QR</option>
                        <option value="EFECTIVO">Pago en efectivo</option>
                        <option value="MIXTO">Mixto</option>
                      </TextField>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        type="number"
                        fullWidth
                        label="Número de cuotas de mensualidad"
                        name="numero_cuotas"
                        value={editEstudiante.numero_cuotas || ""}
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) =>
                          setEditEstudiante((prev) => ({
                            ...prev,
                            numero_cuotas: e.target.value,
                          }))
                        }
                        inputProps={{ min: 1, max: 12 }}
                        helperText="Generará el plan de pagos mensual"
                      />
                    </Grid>
                  </Grid>
                </Paper>

                {/* ==========================================
                    2️⃣ TABLA DE COBROS (MATRÍCULA, MENSUALIDAD Y OTROS)
                    ========================================== */}
                <Paper variant="outlined" sx={{ p: 3, mb: 4, borderRadius: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                    Desglose de Conceptos
                  </Typography>

                  <Grid container spacing={2} alignItems="center">
                    {/* Encabezados */}
                    <Box
                      sx={{
                        display: { xs: "none", md: "grid" },
                        gridTemplateColumns: "2fr 1fr 3fr",
                        gap: 2,
                        mb: 1,
                        fontWeight: "bold",
                        color: "text.secondary",
                        px: 1,
                      }}
                    >
                      <Box sx={{ pl: 1 }}>Concepto</Box>
                      <Box sx={{ pl: 4 }}>Costo</Box>
                      <Box sx={{ pl: 6 }}>Pagado (QR / Efectivo)</Box>
                    </Box>
                    <Grid item xs={12}><Divider sx={{ my: 1 }} /></Grid>

                    {/* --- Fila Matrícula --- */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "2fr 1fr 3fr" },
                        gap: 2,
                        alignItems: "center",
                        p: 1,
                        borderBottom: "1px solid #eee",
                      }}
                    >
                      {/* Concepto */}
                      <Box sx={{ fontWeight: "bold" }}>Matrícula</Box>

                      {/* Costo */}
                      <TextField
                        type="number"
                        size="small"
                        fullWidth
                        label={isMobile ? "Costo matrícula" : ""}
                        inputProps={{ min: 0, step: 0.01 }}
                        name="matricula_costo"
                        onWheel={(e) => e.target.blur()}
                        value={editEstudiante?.matricula_costo ?? ""}
                        onChange={handleChange}
                        required
                      />

                      {/* Pagado */}
                      {editEstudiante.metodo_pago === "MIXTO" ? (
                        <Box sx={{ display: "flex", gap: 1, flexDirection: { xs: "column", sm: "row" } }}>
                          <TextField
                            label="QR"
                            type="number"
                            size="small"
                            inputProps={{ min: 0, step: 0.01 }}
                            value={editEstudiante.matricula_pago_qr ?? 0}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => {
                              const qr = Number(e.target.value) || 0;
                              const ef = Number(editEstudiante.matricula_pago_efectivo) || 0;

                              setEditEstudiante((prev) => ({
                                ...prev,
                                matricula_pago_qr: qr,
                                matricula_pagado: qr + ef,
                              }));
                            }}
                          />

                          <TextField
                            label="Efectivo"
                            type="number"
                            size="small"
                            inputProps={{ min: 0, step: 0.01 }}
                            value={editEstudiante.matricula_pago_efectivo ?? 0}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => {
                              const ef = Number(e.target.value) || 0;
                              const qr = Number(editEstudiante.matricula_pago_qr) || 0;

                              setEditEstudiante((prev) => ({
                                ...prev,
                                matricula_pago_efectivo: ef,
                                matricula_pagado: qr + ef,
                              }));
                            }}
                          />
                        </Box>
                      ) : (
                        <TextField
                          type="number"
                          size="small"
                          fullWidth
                          inputProps={{ min: 0, step: 0.01 }}
                          label={isMobile ? "Pago matrícula" : ""}
                          name="matricula_pagado"
                          value={editEstudiante.matricula_pagado ?? 0}
                          onWheel={(e) => e.target.blur()}
                          onChange={handleChange}
                          required
                        />
                      )}
                    </Box>

                    {/* --- Fila Mensualidad --- */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "2fr 1fr 3fr" },
                        gap: 2,
                        alignItems: "center",
                        p: 1,
                        borderBottom: "1px solid #eee",
                      }}
                    >
                      <Box sx={{ fontWeight: "bold" }}>Mensualidad</Box>

                      <TextField
                        type="number"
                        size="small"
                        fullWidth
                        inputProps={{ min: 0, step: 0.01 }}
                        label={isMobile ? "Costo mensualidad" : ""}
                        name="mensualidad_costo"
                        onWheel={(e) => e.target.blur()}
                        value={editEstudiante.mensualidad_costo ?? ""}
                        onChange={handleChange}
                        required
                      />

                      {editEstudiante.metodo_pago === "MIXTO" ? (
                        <Box sx={{ display: "flex", gap: 1, flexDirection: { xs: "column", sm: "row" } }}>
                          <TextField
                            label="QR"
                            type="number"
                            size="small"
                            inputProps={{ min: 0, step: 0.01 }}
                            value={editEstudiante.mensualidad_pago_qr ?? 0}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => {
                              const val = Number(e.target.value);
                              setEditEstudiante((prev) => ({
                                ...prev,
                                mensualidad_pago_qr: val,
                                mensualidad_pagado: val + (prev.mensualidad_pago_efectivo ?? 0),
                              }));
                            }}
                          />

                          <TextField
                            label="Efectivo"
                            type="number"
                            size="small"
                            inputProps={{ min: 0, step: 0.01 }}
                            value={editEstudiante.mensualidad_pago_efectivo ?? 0}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => {
                              const val = Number(e.target.value);
                              setEditEstudiante((prev) => ({
                                ...prev,
                                mensualidad_pago_efectivo: val,
                                mensualidad_pagado: (prev.mensualidad_pago_qr ?? 0) + val,
                              }));
                            }}
                          />
                        </Box>
                      ) : (
                        <TextField
                          type="number"
                          size="small"
                          fullWidth
                          inputProps={{ min: 0, step: 0.01 }}
                          label={isMobile ? "Pago mensualidad" : ""}
                          name="mensualidad_pagado"
                          value={editEstudiante.mensualidad_pagado ?? 0}
                          onWheel={(e) => e.target.blur()}
                          onChange={handleChange}
                          required
                        />
                      )}
                    </Box>

                    {/* --- Filas Otros Cobros --- */}
                    {selectedItems
                      .filter((item) => item.concepto !== "matricula" && item.concepto !== "mensualidad")
                      .map((item) => (
                        <React.Fragment key={item.id}>
                          <Grid item xs={12}>
                            <Divider sx={{ borderStyle: "dashed" }} />
                          </Grid>

                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: { xs: "1fr", md: "3fr 2fr 5fr" },
                              gap: 2,
                              alignItems: "center",
                              p: 1,
                            }}
                          >
                            {/* Concepto */}
                            <Box sx={{ fontWeight: "medium" }}>{item.concepto}</Box>

                            {/* Costo */}
                            <TextField
                              type="number"
                              size="small"
                              fullWidth
                              inputProps={{ min: 0, step: 0.01 }}
                              onWheel={(e) => e.target.blur()}
                              value={item.monto_total ?? ""}
                              onChange={(e) => {
                                const newSelected = selectedItems.map((itm) =>
                                  itm.id === item.id ? { ...itm, monto_total: Number(e.target.value) } : itm
                                );
                                setSelectedItems(newSelected);
                              }}
                            />

                            {/* Pagado */}
                            {editEstudiante.metodo_pago === "MIXTO" ? (
                              <Box sx={{ display: "flex", gap: 1, flexDirection: { xs: "column", sm: "row" } }}>
                                <TextField
                                  label="QR"
                                  type="number"
                                  size="small"
                                  inputProps={{ min: 0, step: 0.01 }}
                                  onWheel={(e) => e.target.blur()}
                                  value={item.otro_pago_qr ?? ""}
                                  onChange={(e) => {
                                    const val = Number(e.target.value);
                                    const newSelected = selectedItems.map((itm) =>
                                      itm.id === item.id
                                        ? { ...itm, otro_pago_qr: val, monto_pagado: val + (itm.otro_pago_efectivo ?? 0) }
                                        : itm
                                    );
                                    setSelectedItems(newSelected);
                                  }}
                                />

                                <TextField
                                  label="Efe"
                                  type="number"
                                  size="small"
                                  inputProps={{ min: 0, step: 0.01 }}
                                  onWheel={(e) => e.target.blur()}
                                  value={item.otro_pago_efectivo ?? ""}
                                  onChange={(e) => {
                                    const val = Number(e.target.value);
                                    const newSelected = selectedItems.map((itm) =>
                                      itm.id === item.id
                                        ? { ...itm, otro_pago_efectivo: val, monto_pagado: (itm.otro_pago_qr ?? 0) + val }
                                        : itm
                                    );
                                    setSelectedItems(newSelected);
                                  }}
                                />
                              </Box>
                            ) : (
                              <TextField
                                type="number"
                                size="small"
                                fullWidth
                                inputProps={{ min: 0, step: 0.01 }}
                                onWheel={(e) => e.target.blur()}
                                value={item.monto_pagado ?? ""}
                                onChange={(e) => {
                                  const newSelected = selectedItems.map((itm) =>
                                    itm.id === item.id ? { ...itm, monto_pagado: Number(e.target.value) } : itm
                                  );
                                  setSelectedItems(newSelected);
                                }}
                              />
                            )}
                          </Box>
                          {item.tipo_cobro === "mensual" && (
                            <Box
                              sx={{
                                pl: { xs: 1, md: 4 },
                                py: 1,
                                bgcolor: "grey.50",
                                borderRadius: 1,
                                mt: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  display: "grid",
                                  gridTemplateColumns: { xs: "1fr", md: "5fr 3fr" },
                                  gap: 2,
                                  alignItems: "center",
                                }}
                              >
                                {/* Texto */}
                                <Typography variant="body2" color="text.secondary">
                                  Número de cuotas para {item.concepto}:
                                </Typography>

                                {/* Input */}
                                <TextField
                                  type="number"
                                  size="small"
                                  fullWidth
                                  value={item.numero_cuotas_otros_cobros ?? 1}
                                  onChange={(e) => {
                                    const newSelected = selectedItems.map((itm) =>
                                      itm.id === item.id
                                        ? { ...itm, numero_cuotas_otros_cobros: Number(e.target.value) }
                                        : itm
                                    );
                                    setSelectedItems(newSelected);
                                  }}
                                  inputProps={{ min: 1, max: 24 }}
                                />
                              </Box>
                            </Box>
                          )}
                        </React.Fragment>
                      ))}
                  </Grid>
                </Paper>
                <Paper variant="outlined" sx={{ p: 3, mb: 4, borderRadius: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                    Añadir Otros Cobros Disponibles
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {items.map((item) => (
                      <FormControlLabel
                        key={item.id}
                        control={
                          <Checkbox
                            checked={selectedItems.some(
                              (si) => norm(si.concepto) === norm(item.concepto)
                            )}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedItems((prev) => [
                                  ...prev,
                                  {
                                    ...item,
                                    monto_total: item.costo_unitario || "",
                                    monto_pagado: "",
                                  },
                                ]);
                              } else {
                                setSelectedItems((prev) =>
                                  prev.filter(
                                    (si) =>
                                      norm(si.concepto) !== norm(item.concepto)
                                  )
                                );
                              }
                            }}
                          />
                        }
                        label={item.concepto}
                      />
                    ))}
                  </Box>
                </Paper>
                <Paper elevation={0} sx={{ p: 3, bgcolor: "grey.100", borderRadius: 2 }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={6}>
                      <Typography variant="h6" fontWeight="bold" color="success.main">
                        Total pagado: Bs. {calcularTotalPagado().toFixed(2)}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="h6" fontWeight="bold" color="error.main" textAlign={{ xs: "left", md: "right" }}>
                        Deuda acumulada: Bs. {calcularDeudaAcumulada()}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Box>
            )}
            {/* ---------------------- NAVEGACIÓN ENTRE PASOS ---------------------- */}
            <Box mt={4} display="flex" justifyContent="space-between" alignItems="center">
              {/* Botón cancelar a la izquierda */}
              <MDButton color="secondary" onClick={handleClose}>
                Cancelar
              </MDButton>

              {/* Grupo de botones: Atrás + Siguiente */}
              <Box display="flex" sx={{ borderRadius: '8px', overflow: 'hidden', boxShadow: 1 }}>
                {step > 1 && (
                  <MDButton
                    color="info"
                    onClick={handlePrevStep}
                    sx={{
                      borderTopRightRadius: 0,
                      borderBottomRightRadius: 0,
                    }}
                  >
                    Atrás
                  </MDButton>
                )}

                {step < maxStep ? (
                  <MDButton
                    color="info"
                    onClick={handleNextStep}
                    sx={{
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      borderLeft: '1px solid rgba(255,255,255,0.3)',
                    }}
                  >
                    Siguiente
                  </MDButton>
                ) : (
                  <MDButton
                    color="success"
                    onClick={() => {
                      const stepErrors = validarPorPaso();
                      setErrors(stepErrors);

                      if (Object.keys(stepErrors).length === 0) {
                        handleSaveEstudiante();
                      } else {
                        console.log("Errores en el paso", step, stepErrors);
                      }
                    }}
                    sx={{
                      borderTopLeftRadius: step > 1 ? 0 : '8px',
                      borderBottomLeftRadius: step > 1 ? 0 : '8px',
                      borderLeft: '1px solid rgba(255,255,255,0.3)',
                    }}
                  >
                    {ui.isSaving ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : modoEdicion ? "Actualizar" : "Guardar"}
                  </MDButton>
                )}
              </Box>
            </Box>
          </Box>
        </Modal>
        <Kardex
          open={kardexOpen}
          handleClose={() => setKardexOpen(false)}
          usuarioId={kardexUserId}
        />
      </div>
    );
  }
